<template>
  <div>
    <Benefit v-if="!isMatter" :sku="sku" />
    <Matter v-else :sku="sku" />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  computed,
  ref,
} from "@vue/composition-api";
import Vue from "vue";

import { getSkuByBenefitType } from "@/apis";
import { useRoute, useRouter, useStore } from "@/components/use/base";

import Benefit from "./benefit/index.vue";
import Matter from "./Matter/index.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    Benefit,
    Matter,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const isMatter = ref(false);
    const sku = ref([]);

    const namespace = computed(() => store.state.namespace);
    const source = computed(() => store.state.source);

    onMounted(async () => {
      if (
        !store.state.token &&
        store.getters.getConfigValue("HOTEL_SINGLE_BENEFIT2")
      ) {
        router.push(
          `/loginPage?redirect=${encodeURIComponent(route.fullPath)}`
        );
        return;
      }
      const loading = vm.$loading();

      try {
        const { benefit_type } = route.query;
        const { data } = await getSkuByBenefitType({
          benefit_type,
          namespace: namespace.value,
          source: source.value,
        });
        isMatter.value = !!data[0].benefit_category;
        sku.value = data;
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    });

    return {
      isMatter,
      sku,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
